import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

const CIConfirmPopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <Popup
      isOpen={store.isCIConfirmPopupOpen}
      mainBtn={{
        label: '본인 인증하기',
        onClick: () => store.waitForCIPopup?.complete(true),
      }}
      subBtn={{
        label: '닫기',
        onClick: () => store.waitForCIPopup?.complete(false),
      }}
    >
      {{ title: 'NOL 카드 가입을 위해\n본인 인증을 진행해 주세요' }}
    </Popup>
  );
};

export default observer(CIConfirmPopup);
